package com.eladfinish.bible.contest.ui.components.buttons

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Surface
import androidx.compose.material3.ripple
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorPrimaryDark
import com.eladfinish.bible.contest.strokeColor
import dev.icerock.moko.resources.compose.colorResource

@Composable
fun ItemButtonWithLongClick(
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    transparentBackground: Boolean = false,
    borderWidth: Int = 1,
    contentPadding: PaddingValues = PaddingValues(
        horizontal = 16.dp,
        vertical = 10.dp,
    ),
    onClick: () -> Unit,
    onLongClick: (() -> Unit)? = null,
    content: @Composable BoxScope.() -> Unit,
) {
    val shape = RoundedCornerShape(12.dp)
    val interactionSource = remember { MutableInteractionSource() }

    val containerColor = if (transparentBackground) {
        Color.Transparent
    } else {
        colorResource(resource = SharedRes.colors.colorPrimaryDark)
    }

    val borderColor = colorResource(resource = SharedRes.colors.strokeColor)

    Surface(
        modifier = modifier,
        shape = shape,
        color = containerColor,
        border = if (borderWidth != 0) {
            BorderStroke(
                width = borderWidth.dp,
                color = borderColor,
            )
        } else {
            null
        },
        tonalElevation = 0.dp,
        shadowElevation = 0.dp,
    ) {
        Box(
            modifier = Modifier
                .defaultMinSize(
                    minHeight = 48.dp,
                )
                .combinedClickable(
                    enabled = enabled,
                    role = Role.Button,
                    interactionSource = interactionSource,
                    indication = ripple(),
                    onClick = onClick,
                    onLongClick = onLongClick,
                )
                .padding(contentPadding),
            contentAlignment = Alignment.Center,
            content = content,
        )
    }
}
